import React from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
    ResponsiveContainer,
} from "recharts";

export default function UserGrowthBarChart({ rawGrowth, selectedYear }) {
    // Get theme colors from CSS variables
    const getThemeColor = (variable) => {
        if (typeof window !== 'undefined') {
            return getComputedStyle(document.documentElement)
                .getPropertyValue(variable)
                .trim() || '#000';
        }
        return '#000';
    };

    const primaryColor = getThemeColor('--primary-solid') || '#a855f7';
    const textColor = getThemeColor('--text-secondary') || '#c4bad8';
    const gridColor = 'rgba(139, 92, 246, 0.18)';

    // Use selectedYear instead of current year
    const fullGrowth = Array.from({ length: 12 }).map((_, index) => {
        const monthName = new Date(selectedYear, index).toLocaleDateString("en-US", {
            month: "short",
        });

        return {
            month: monthName,
            count: 0,
        };
    });

    // Map API data correctly
    rawGrowth.forEach((item) => {
        const monthIndex = item.month - 1;
        if (fullGrowth[monthIndex]) {
            fullGrowth[monthIndex].count = item.count;
        }
    });

    return (
        <div className="w-full overflow-x-auto">
            <div className="min-w-[600px] h-72">
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={fullGrowth} margin={{ top: 10, right: 12, left: -10, bottom: 0 }}>
                        <defs>
                            <linearGradient id="barGradient" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="0%" stopColor="#a855f7" stopOpacity={1} />
                                <stop offset="100%" stopColor="#ec4899" stopOpacity={0.85} />
                            </linearGradient>
                        </defs>
                        <CartesianGrid strokeDasharray="3 3" stroke={gridColor} vertical={false} />
                        <XAxis 
                            dataKey="month" 
                            stroke={textColor} 
                            style={{ fontSize: '12px' }}
                            tickLine={false}
                            axisLine={{ stroke: gridColor }}
                        />
                        <YAxis 
                            stroke={textColor} 
                            style={{ fontSize: '12px' }}
                            tickLine={false}
                            axisLine={false}
                        />
                        <Tooltip
                            cursor={{ fill: 'rgba(168, 85, 247, 0.06)' }}
                            contentStyle={{
                                background: "linear-gradient(180deg, #17103d, #120c30)",
                                border: "1px solid rgba(139,92,246,0.32)",
                                borderRadius: "12px",
                                color: "#f8f5ff",
                                boxShadow: "0 16px 40px rgba(0,0,0,0.5)",
                            }}
                            labelStyle={{ 
                                color: primaryColor,
                                fontWeight: "700",
                                marginBottom: "4px",
                            }}
                            itemStyle={{ color: "#f8f5ff", fontWeight: 600 }}
                        />
                        <Bar
                            dataKey="count"
                            fill="url(#barGradient)"
                            barSize={32}
                            radius={[8, 8, 0, 0]}
                        />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}
